import React from 'react';
import { Badge } from '../ui/badge';
import { Shield } from 'lucide-react';

export function AdminOverviewTab({ 
  clubs, 
  users, 
  siteSettings, 
  toggleHomepageStats,
  toggleHomepageDJs 
}) {
  return (
    <div className="grid lg:grid-cols-2 gap-6">
      {/* Site Settings Card */}
      <div className="lg:col-span-2 bg-white rounded-xl p-6 shadow-sm border border-slate-200">
        <h3 className="font-bold text-slate-900 mb-4 flex items-center">
          <Shield className="w-5 h-5 mr-2 text-violet-600" />
          Site Settings
        </h3>
        <div className="space-y-4">
          <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg">
            <div>
              <p className="font-medium text-slate-900">Show Homepage Statistics</p>
              <p className="text-sm text-slate-500">Display registered users, clubs, and events count on the homepage</p>
            </div>
            <button
              onClick={toggleHomepageStats}
              className={`relative w-12 h-6 rounded-full transition-colors ${
                siteSettings.show_homepage_stats ? 'bg-violet-600' : 'bg-slate-300'
              }`}
              data-testid="toggle-homepage-stats"
            >
              <span 
                className={`absolute top-1 w-4 h-4 bg-white rounded-full shadow transition-transform ${
                  siteSettings.show_homepage_stats ? 'left-7' : 'left-1'
                }`}
              />
            </button>
          </div>
          <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg">
            <div>
              <p className="font-medium text-slate-900">Show DJs Section on Homepage</p>
              <p className="text-sm text-slate-500">Display the Featured DJs section on the homepage</p>
            </div>
            <button
              onClick={toggleHomepageDJs}
              className={`relative w-12 h-6 rounded-full transition-colors ${
                siteSettings.show_homepage_djs ? 'bg-violet-600' : 'bg-slate-300'
              }`}
              data-testid="toggle-homepage-djs"
            >
              <span 
                className={`absolute top-1 w-4 h-4 bg-white rounded-full shadow transition-transform ${
                  siteSettings.show_homepage_djs ? 'left-7' : 'left-1'
                }`}
              />
            </button>
          </div>
        </div>
      </div>

      {/* Recent Clubs */}
      <div className="bg-white rounded-xl p-6 shadow-sm">
        <h3 className="font-bold text-slate-900 mb-4">Recent Clubs</h3>
        <div className="space-y-3">
          {clubs.slice(0, 5).map(club => (
            <div key={club.club_id} className="flex items-center justify-between py-2 border-b border-slate-100 last:border-0">
              <div>
                <p className="font-medium text-slate-900">{club.name}</p>
                <p className="text-sm text-slate-500">{club.location || [club.city, club.region, club.country].filter(Boolean).join(', ') || 'Location not specified'}</p>
              </div>
              {club.is_featured && (
                <Badge className="bg-violet-100 text-violet-700">Featured</Badge>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Recent Users */}
      <div className="bg-white rounded-xl p-6 shadow-sm">
        <h3 className="font-bold text-slate-900 mb-4">Recent Users</h3>
        <div className="space-y-3">
          {users.slice(0, 5).map(u => (
            <div key={u.user_id} className="flex items-center justify-between py-2 border-b border-slate-100 last:border-0">
              <div>
                <p className="font-medium text-slate-900">{u.name}</p>
                <p className="text-sm text-slate-500">{u.email}</p>
              </div>
              {u.is_admin && (
                <Badge className="bg-slate-900 text-white">Admin</Badge>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
